// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";

const metadata: BuiltInScriptMetadata = {
  name: "Generic Projectile Aim No Gravity",
  id: "generic-projectile-aim-no-gravity",
  metadata: {
    imports: ["projectile"],
    icon: {
      backgroundColor: 2430764,
      layers: [
        {
          iconKey: "fireball",
          position: {
            x: 0,
            y: 0
          },
          scale: 0.95,
          rotation: 7,
          color: 4124908
        }
      ]
    }
  }
};

export default metadata;
